export const JOURNEY_BUILDER_PATH = '/journeybuilder/:activityType';



// WEBPACK FOOTER //
// ./src/Shared/Routing/routingPaths.js